import styled from 'styled-components';

const Error = styled.div`
  display: flex;
  flex-wrap: wrap;
  background-color: rgba(255, 255, 255, 0.2);
  justify-content: center;
  width: 50%;
  margin: 3rem auto;
  border-radius: 5px;

  p {
    color: white;
    font-family: 'Concert One';
    text-align: center;
  }
`;

export default Error;
